import React, { useState, useEffect, useRef } from "react";
import { useLoader } from "../../Common/GeneralLoader/GeneralLoaderProvider";
import { createElement, init } from "@airwallex/components-sdk";
import { getEmbeddedInitApi } from "../../../api/api";
import { drupalSettings } from "../../../utils/config";
import {
  hasSdkSubmissionError,
  isBeneficiaryFormDataComplete,
} from "../../Common/beneficiaryValidation";

export const AirWallexNewTransfer = ({ setStep, payload, setPayload }) => {
  const [error, setError] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const { showLoader, hideLoader } = useLoader(); // Destructure isLoading, showLoader, and hideLoader

  const formErrors = {
    technical_error:
      Drupal.t("Sorry, there was an error. Please try again later or reach out to support@nautzero.com."),
    form_incomplete: Drupal.t("Please complete all required fields before continuing."),
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError("");

    if (!beneficiaryFormRef.current) return;

    const submitResult = await beneficiaryFormRef.current.submit();
    console.log("submitResult 2", submitResult);

    if (hasSdkSubmissionError(submitResult)) {
      setError(true);
      // Do not show our banner; SDK surfaces the issue inline.
      return;
    }

    if (!isBeneficiaryFormDataComplete(submitResult?.values || {})) {
      setError(true);
      setSubmitError(formErrors.form_incomplete);
      return;
    }

    setError(false);
    setPayload({
      ...payload,
      beneficiaryFormData: submitResult.values,
    });
    setStep(2);
  };

  const beneficiaryFormRef = useRef();

  useEffect(() => {
    const initAndRenderElement = async () => {
      showLoader();
      try {
        // 1. Call your Drupal API to get authCode, clientId, codeVerifier
        const response = await getEmbeddedInitApi({ yacht_id: drupalSettings?.user?.yacht_id });

        const { authCode, clientId, codeVerifier } = response.data;

        // 2. Init Airwallex SDK
        await init({
          locale: "en",
          env: response?.env || "demo", // or "production"
          authCode,
          clientId,
          codeVerifier,
        });

        const element = await createElement("beneficiaryForm", {
          defaultValues: payload?.beneficiaryFormData || {},
          customizations: {
            ui: {
              hideFeeConfig: true,
              // hideFlightTime: false
            },
            fields:{
              'beneficiary.additional_info.personal_email':{
                hidden: true
              },
              'nickname':{
                hidden: true
              },
              'beneficiary.company_name':{
                hidden: true
              },
              'beneficiary.first_name':{
                hidden: true
              },
              'beneficiary.last_name':{
                hidden: true
              }
            },
          },
        });
        element.mount("#beneficiary-root");
        beneficiaryFormRef.current = element;
      } catch (err) {
        console.log("Failed to fetch Embedded Component init info");
      } finally {
        hideLoader();
      }
    };

    initAndRenderElement();
  }, []);

  return (
    <>
      <div className="add-recipient-header">
        <h4 className="add-recipient-title">Add a New <span className="yellow">Recipient</span></h4>
      </div>
      <div className="add-recipient-body-content">
        <form className="add-new-recipient-form">
          {submitError && (
            <div className="popup-has-error">
              <div className="error_messages">{submitError}</div>
            </div>
          )}
          <div id="beneficiary-root" />
					<div className="add-recipient-actions">
            <button className="primary__btn" type="submit" onClick={handleSubmit}>Confirm</button>
          </div>
				</form>
      </div>
    </>
  );
};
